module.exports = __webpack_public_path__ + "media/member-joined.f4b1517d.ogg";